import { useState } from 'react';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Button } from '@/common/components/Button/Button';
import { Dialog } from '@/common/components/Dialog/Dialog';
import { Divider } from '@/common/components/Divider/Divider';
import { Drawer } from '@/common/components/Drawer/Drawer';
import { Icon } from '@/common/components/Icons/Icon';
import { IllustrationCard } from '@/common/components/Illustrations/IllustrationCard';
import { IlustrationNoFamilyMembers } from '@/common/components/Illustrations/IlustrationNoFamilyMembers';
import { Modal } from '@/common/components/Modal/Modal';
import { ModalLearning } from '@/common/components/ModalLearning/ModalLearning';
import { ModalMultiStep } from '@/common/components/ModalMultiStep/ModalMultiStep';
import { Stack } from '@/common/components/Stack/Stack';

export const PlaygroundModals = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isModalMultiStepOpen, setIsModalMultiStepOpen] = useState(false);
  const [isLearningOpen, setIsLearningOpen] = useState(false);
  const [isLearningLargeOpen, setIsLearningLargeOpen] = useState(false);
  return (
    <Stack gap="md">
      <Button onPress={() => setIsModalOpen(true)}>Open Modal</Button>
      {isModalOpen && (
        <Modal
          onClose={() => setIsModalOpen(false)}
          size="sm"
          title="This is a modal"
          icon={<Icon icon="language" />}
          footer={({ close }) => <Button onPress={close}>Footer</Button>}
        >
          <BodyText>
            Im inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            Im inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            Im inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            Im inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
          </BodyText>
        </Modal>
      )}
      <Divider />
      <Button onPress={() => setIsModalMultiStepOpen(true)}>
        Open Modal Multi Step
      </Button>
      {isModalMultiStepOpen && (
        <ModalMultiStep
          icon={<Icon icon="baby" />}
          title="This is a modal multi step"
          heightClass="h-[40rem]"
          backgroundColor="accentSecondary10"
          steps={[
            {
              content: <BodyText>This is the first step</BodyText>,
              actions: ({ onNext }) => <Button onPress={onNext}>Next</Button>,
            },
            {
              content: (
                <BodyText>
                  This is the second step Im inside the modal 1212 generate
                  lorem ipsum dolor sit amet consectetur adipiscing elit sed do
                  eiusmod tempor incididunt ut Im inside the modal 1212 generate
                  lorem ipsum dolor sit amet consectetur adipiscing elit sed do
                  eiusmod tempor incididunt ut Im inside the modal 1212 generate
                  lorem ipsum dolor sit amet consectetur adipiscing elit sed do
                  eiusmod tempor incididunt ut Im
                </BodyText>
              ),
              actions: ({ onBack }) => <Button onPress={onBack}>Back</Button>,
            },
          ]}
          onClose={() => setIsModalMultiStepOpen(false)}
        />
      )}
      <Divider />
      <Button onPress={() => setIsDrawerOpen(true)}>Open Drawer</Button>
      {isDrawerOpen && (
        <Drawer
          onClose={() => setIsDrawerOpen(false)}
          size="sm"
          title="This is a Drawer"
          icon={<Icon icon="language" />}
          footer={<Button>Footer</Button>}
        >
          <BodyText>
            Im inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
            inside the modal 1212 generate lorem ipsum dolor sit amet
            consectetur adipiscing elit sed do eiusmod tempor incididunt ut Im
          </BodyText>
        </Drawer>
      )}
      <Divider />
      <Button onPress={() => setIsDialogOpen(true)}>Open Dialog</Button>
      {isDialogOpen && (
        <Dialog
          icon={<Icon icon="baby" />}
          title="This is a dialog"
          message="This is a dialog message"
          secondaryAction={{
            children: 'Secondary',
          }}
          primaryAction={{
            children: 'Primary',
          }}
          onClose={() => setIsDialogOpen(false)}
        />
      )}
      <Divider />
      <Button onPress={() => setIsLearningOpen(true)}>Open Learning</Button>
      {isLearningOpen && (
        <ModalLearning.Root
          heightClass="h-[50rem]"
          onClose={() => setIsLearningOpen(false)}
        >
          <ModalLearning.Step
            title="Coverflex App"
            description={
              <BodyText>
                {
                  'You can use your benefits balance to invest in Retirement and Savings products directly through your app.\n\nSelect the entity, the product, and the amount you’d like to invest and fill in the required information. Your funds will be transferred to the selected entity to open your investment account. After that, you’ll also be able to use your balance to top-up your investment.\n\nCoverflex offers investment products from Real Vida Seguros, Casa de Investimentos, and Optimize, encompassing different levels of risk, investment, flexibility, and return to fit your needs. After the initial investment and additional top-ups, you can manage your investments directly with the selected entity.'
                }
              </BodyText>
            }
            asset={<IllustrationCard />}
          />
          <ModalLearning.Step
            title="This is the second step"
            description="This is the second step description. With a very long description that will wrap around the asset"
            asset={<IlustrationNoFamilyMembers />}
          />
        </ModalLearning.Root>
      )}
      <Divider />
      <Button onPress={() => setIsLearningLargeOpen(true)}>
        Open Learning Large
      </Button>
      {isLearningLargeOpen && (
        <ModalLearning.Root
          heightClass="h-[50rem]"
          onClose={() => setIsLearningLargeOpen(false)}
          assetContainerSize="lg"
        >
          <ModalLearning.Step
            title="Coverflex App"
            description="This is the first step description"
            asset={<IllustrationCard />}
          />
          <ModalLearning.Step
            title="This is the second step"
            description="This is the second step description. With a very long description that will wrap around the asset"
            asset={<IlustrationNoFamilyMembers />}
          />
        </ModalLearning.Root>
      )}
    </Stack>
  );
};
